import React from 'react';
import styled from 'styled-components';
import Constants from '../../submodules/logictry_config/constants';

const BadgeOuter = styled.div`
  width: 13px;
  height: 13px;
  background: white;
  ${Constants.isDarkMode ? 'filter: invert(1);' : ''}
  border-radius: 50%;
  position: absolute;
  right: -4px;
  top: -5px;
  pointer-events: none;
`;

const BadgeInner = styled.div`
  width: 9px;
  height: 9px;
  background: red;
  border-radius: 50%;
  margin: 2px;
`;

/** Unread indicator — parent icon must have `position: relative`. */
export default function IconBadgeDot({ 'aria-hidden': ariaHidden = true }) {
  return (
    <BadgeOuter aria-hidden={ariaHidden}>
      <BadgeInner />
    </BadgeOuter>
  );
}
